import type { ErrorInfo } from 'react';

import { TwoFactorBoundaryError } from '../types/index';

export function getTwoFactorBoundaryError(
  error: Error,
  errorInfo: ErrorInfo,
  action: string,
  packageData: { name: string; version: string },
): TwoFactorBoundaryError {
  return {
    error,
    errorInfo,
    context: packageData.name,
    details: {
      version: packageData.version,
      action,
    },
  };
}

export function getErrorObject(error: Error | string | undefined | unknown) {
  if (typeof error === 'string') {
    return new Error(error);
  }

  if (error instanceof Error) {
    return error;
  }

  return undefined;
}

export class IdentityApiError extends Error {
  type: string;

  apiError?: unknown;

  code?: string;

  constructor(message: string, type: string, apiError?: unknown, code?: string) {
    super(message);
    this.name = 'IdentityApiError';
    this.type = type;
    this.apiError = apiError;
    this.code = code;
  }
}
